import React from "react";
import PropTypes from "prop-types";
import { Table, Button, ModalFooter } from "reactstrap";
import { formatCurrency } from "common/number-formatter";

const propTypes = {
  flowData: PropTypes.shape({
    zip_spots: PropTypes.arrayOf(
      PropTypes.shape({
        postal_code: PropTypes.string,
        spots: PropTypes.number,
        spot_type: PropTypes.string,
        paid_unit_price: PropTypes.number,
        paid_total: PropTypes.number
      })
    ),
    total_cost: PropTypes.number,
    cost_duration_display: PropTypes.number,
    paid_through: PropTypes.string,
    renewal_date: PropTypes.string
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const AccountSummaryStep = ({ flowData, onContinue, onKeep }) => {
  const {
    zip_spots: zipSpots,
    total_cost: totalCost,
    cost_duration_display: costDurationDisplay,
    paid_through: paidThrough,
    renewal_date: renewalDate
  } = flowData;

  return (
    <div>
      <p className="text-center text-muted mb-3">First, let&apos;s review your account.</p>
      {paidThrough && (
        <p className="text-center mb-3">Your account is paid up through {paidThrough}.</p>
      )}

      {zipSpots && zipSpots.length > 0 && (
        <Table bordered hover size="sm" className="mb-3">
          <thead>
            <tr>
              <th>Zip Code</th>
              <th className="text-center"># of Spots</th>
              <th className="text-center">Price per Spot</th>
              <th className="text-center">Total Cost per Zip</th>
            </tr>
          </thead>
          <tbody>
            {zipSpots.map(z => (
              <tr key={`${z.postal_code}-${z.spot_type}`}>
                <td>{z.postal_code}</td>
                <td className="text-center">
                  {z.spots}{" "}
                  {z.spot_type
                    ? `${z.spot_type} spot${z.spots !== 1 ? "s" : ""}`
                    : `spot${z.spots !== 1 ? "s" : ""}`}
                </td>
                <td className="text-center">{formatCurrency(z.paid_unit_price)} / mo</td>
                <td className="text-center">
                  {formatCurrency(z.paid_total)} / {costDurationDisplay} days
                </td>
              </tr>
            ))}
            <tr className="font-weight-bold">
              <td colSpan={3} className="text-right">
                Total Cost
              </td>
              <td className="text-center">
                {formatCurrency(totalCost)} / {costDurationDisplay} days
              </td>
            </tr>
          </tbody>
        </Table>
      )}

      {renewalDate && (
        <p className="text-center text-muted mb-0">
          Your next payment will not occur until {renewalDate}. Are you sure you want to cancel?
        </p>
      )}

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onContinue}>
          Continue Cancel Process
        </Button>
        <Button color="primary" className="btn-sharp" onClick={onKeep}>
          Don&apos;t Cancel
        </Button>
      </ModalFooter>
    </div>
  );
};

AccountSummaryStep.propTypes = propTypes;

export default AccountSummaryStep;
